export default __webpack_public_path__ + "static/media/Robotic-Cleaner-Category-Offer.7b9cc3b1.png";